module.exports = mycorvinus_cte;